import { Col, Divider, Row } from "antd";
import "moment-timezone";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Percent from "../../../../assets/icons/percentage-discount.svg";
import Shelter from "../../../../assets/icons/shelter.png";
import { CapsuleButton } from "../../../../CommonComponents/Commons/commonComponents";
import { DataHeading, DataValue, DisplayFlex, EllipsisContent, EllipsisDataValueWrapper, EllipsisUnderline, HeaderDataWrapper, SectionLastHeading } from "../../../../CommonComponents/commonStyles";
import { ContentMessage, Types } from "../../../../CommonComponents/ContentMessages";
import Profile from "../../../../CommonComponents/svgs/Profile";
import { dateFormatter, initiateTracking, recordError } from "../../../../utils/commonUtil";
import { isGeminiUser } from "../../../../utils/sessionUtil";
import { ItemData, ItemHeading, PersonnelHeading } from "../../styles";
import { CharityIcon, CharityList, ContentData, GeminiViewContainerWithNotes, HeaderData, NotesDataContainer, NotesStringContainer, OptionsCard, Percentage, PercentageImage, PercentageOthers } from "./styles";
export default class SuccessionComponent extends Component {
  constructor(props) {
    super(props);
    this.successorAdvisorTitle = '';
    this.createAccountTitle = '';
    this.philanthropicTitle = '';
    this.giveCharityTitle = '';
    this.grantAnnualTitle = '';
    this.state = {
      currentItemId: undefined,
      successionData: this.props.data
    };
  }
  geminiUser = isGeminiUser();
  clickHandler = (key, sectionName) => {
    try {
      if (sectionName) {
        initiateTracking("showMore", this.props.pageTitle(), sectionName, "Show More");
      }
      const currentItemId = key !== this.state.currentItemId ? key : undefined;
      this.setState({ currentItemId });
    } catch (error) {
      recordError(error);
    }
  };
  generateSuccessors(data,notes='') {
    let legacyData = data;
    data = legacyData.successorAdvisor
    return (
      <>
        <CharityList>
          <Divider className="my-20" />
          {data && data.length > 0 ? (
            data.map((item, index) => (
              <Col lg={8} md={8} xs={24}>
                <Row>
                  <Col lg={2} md={2} xs={2}>
                    <div className="mt-05">
                      <Profile />
                    </div>
                  </Col>
                  <Col lg={22} md={22} xs={22}>
                    <div className="mb1">
                      <PersonnelHeading>Successor {index + 1}</PersonnelHeading>
                    </div>
                    <ItemData className="mt0">
                      {item.title ? `${item.title} ` : ""} 
                    {item.firstName}
                    {item.middleName ? ` ${item.middleName}` : ""} 
                    {` ${item.lastName}`}
                    {item.suffix ? `, ${item.suffix} ` : ""} 
                    </ItemData>
                    <DisplayFlex className="mt-05">
                      <ItemHeading>Email : </ItemHeading>
                      <ItemData className="mt0 ml-05">
                        {item.preferedEmail === null || item.preferedEmail === "" ? (
                          <> &mdash; </>
                        ) : (
                            <EllipsisDataValueWrapper>
                              <EllipsisUnderline>{item.preferedEmail}</EllipsisUnderline>
                              <EllipsisContent>
                                {item.preferedEmail}
                              </EllipsisContent>
                            </EllipsisDataValueWrapper>
                          )}
                      </ItemData>
                    </DisplayFlex>
                    <DisplayFlex className="mt-05">
                      <ItemHeading>Phone : </ItemHeading>
                      <ItemData className="mt0 ml-05">
                        {item.preferedPhone === null || item.preferedPhone === "" ? (
                          <> &mdash; </>
                        ) : (
                            item.preferedPhone
                          )}
                      </ItemData>
                    </DisplayFlex>
                    <DisplayFlex className="mt-05">
                      <ItemHeading>Address : </ItemHeading>
                      <div>
                        <ItemData className="mt0 ml-05">
                          {item.address.line1
                            ? `${item.address.line1}, `
                            : ""}
                        </ItemData>
                        <ItemData className="mt0 ml-05">
                          {item.address.line2
                            ? `${item.address.line2}, `
                            : ""}
                        </ItemData>
                        <ItemData className="mt0 ml-05">
                          {item.address.line3
                            ? `${item.address.line3}, `
                            : ""}
                        </ItemData>
                        <ItemData className="mt0 ml-05">
                          {item.address.line4
                            ? `${item.address.line4}, `
                            : ""}
                        </ItemData>
                        <ItemData className="mt0 ml-05">
                          {item.address.city ? `${item.address.city}, ` : ""}
                          {item.address.state ? `${item.address.state}, ` : null}
                          {item.address.zip ? `${item.address.zip}, ` : ""}
                        </ItemData>
                        <ItemData className="mt0 ml-05">
                          {item.address.country}
                        </ItemData>
                      </div>
                    </DisplayFlex>
                    <DisplayFlex className="mt-05">
                      <ItemHeading>Relation : </ItemHeading>
                      <ItemData className="mt0 ml-05">
                        {item.relationship === null || item.relationship === "" ? (
                          <> &mdash; </>
                        ) : (
                            item.relationship
                          )}
                      </ItemData>
                    </DisplayFlex>
                    <DisplayFlex className="mt-05">
                      <ItemHeading>Date of birth : </ItemHeading>
                      <ItemData className="mt0 ml-05">
                        {/* MSP-1329 Birthdate displaying incorrectly to donor on DP */}
                        {item.dobStr ? (
                          dateFormatter(item.dobStr)
                        ) : (
                            <> &mdash; </>
                          )}
                      </ItemData>
                    </DisplayFlex>
                  </Col>
                </Row>
              </Col>
            ))
          ) : (
              <ItemHeading>No Data found</ItemHeading>
            )}
        </CharityList>
        <Row>
          {this.geminiUser &&
            <>
              <GeminiViewContainerWithNotes>
                <NotesStringContainer><ItemHeading>Notes: </ItemHeading></NotesStringContainer>
                <NotesDataContainer>
                  <ItemData>
                    {notes ? notes : <> &mdash; </>}
                  </ItemData>
                </NotesDataContainer>
              </GeminiViewContainerWithNotes>
            </>
          }
        </Row>
      </>
    );
  }
  setTitle = (title = '', type = '') => {
    if (type === 'successorAdvisors') {
      this.successorAdvisorTitle = title;
    }
    if (type === 'createAccount') {
      this.createAccountTitle = title;
    }
    if (type === 'philanthropic') {
      this.philanthropicTitle = title;
    }
    if (type === 'giveToCharity') {
      this.giveCharityTitle = title;
    }
    if (type === 'grantAnnually') {
      this.grantAnnualTitle = title;
    }
  }
  viewEndowedGrantPlanPdf = (content) => {
    let elem = document.querySelector("#grantAnually a:last-child");
    if (elem) {
      let elemText = elem.textContent;
      elem.addEventListener("click", () => {
        initiateTracking('download', this.props.pageTitle(), this.grantAnnualTitle, elemText);
      })
    }
  }
  render() {
    const legacy = this.state.successionData;    
    return (
      <div className="succession-cnt" data-test="succession-component">
        {/******************************** Bestow to Others ************************************/}
        {legacy.bestowLegacy && (
          <>
            {legacy.bestowLegacy.appoint && parseInt(legacy.bestowLegacy.appoint.assignedPercentage) === 0 &&
              legacy.bestowLegacy.create && parseInt(legacy.bestowLegacy.create.assignedPercentage) === 0 ? (
                ""
              ) : (
                <>
                  <DataValue className="mb-30">Bestow to others</DataValue>
                  {legacy.bestowLegacy.appoint && parseInt(legacy.bestowLegacy.appoint.assignedPercentage) !== 0 ? (
                    <OptionsCard>
                      <HeaderDataWrapper data-test="bestowToOtherheader" onClick={() => {
                        this.clickHandler(1);
                      }}>
                        <HeaderData>
                          <SectionLastHeading className="mb0">
                            <ContentMessage data-test="bestowLegacyContentMsg" type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="Legacy options" property="field_type_1_title" setTitle={(title) => this.setTitle(title, 'successorAdvisors')} defaultMessage="Add up to two successor advisors" />
                          </SectionLastHeading>
                          <DataHeading>
                            <ContentMessage messageId="addSuccAdvisor" type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="Legacy options" html={true} property="field_type_1_description" defaultMessage="Please assign a percentage of the remaining account assets to your successor advisor(s). This percentage will be assigned to one successor advisor or split between two successor advisors, if you name a second successor advisor." />
                          </DataHeading>
                          <Percentage textColor="#69923a">
                            {legacy.bestowLegacy.appoint.assignedPercentage}%
                      </Percentage>
                        </HeaderData>
                      </HeaderDataWrapper>
                      <ContentData>
                        {this.state.currentItemId === 1
                          ? this.generateSuccessors(
                            legacy.bestowLegacy.appoint,legacy.bestowLegacy.appoint.notes ? legacy.bestowLegacy.appoint.notes: ''
                          )
                          : null}
                        {this.state.currentItemId === 1 ? (
                          <div className="mt-30">
                            <CapsuleButton text="Show Less" data-test="showLessCapsule" whiteBackground iconType="arrowUp" onClick={() => {
                              this.clickHandler(1);
                            }} />
                          </div>
                        ) : (
                            <div className="mt-30">
                              <CapsuleButton text="Show More" data-test="showMoreCapsule" whiteBackground iconType="arrowDown" onClick={() => {
                                this.clickHandler(1, this.successorAdvisorTitle);
                              }} />
                            </div>
                          )}
                      </ContentData>
                    </OptionsCard>
                  ) : (
                      ""
                    )}
                  {legacy.bestowLegacy.create && parseInt(legacy.bestowLegacy.create.assignedPercentage) !== 0 ? (
                    <OptionsCard>
                      <HeaderDataWrapper data-test="bestowToLegacyCreate" onClick={() => {
                        this.clickHandler(2);
                      }}>
                        <HeaderData>
                          <SectionLastHeading className="mb0">
                            <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="Legacy options" property="field_type_2_title" setTitle={(title) => this.setTitle(title, 'createAccount')} defaultMessage="Create accounts" />
                          </SectionLastHeading>
                          <DataHeading>
                            <ContentMessage messageId="createAccount" type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="Legacy options" html={true} property="field_type_2_description" defaultMessage="Create new charitable giving account(s) for named successor advisor(s)." />
                          </DataHeading>
                          <Percentage textColor="#69923a">
                            {legacy.bestowLegacy.create.assignedPercentage}%
                      </Percentage>
                        </HeaderData>
                      </HeaderDataWrapper>
                      <ContentData>
                        {this.state.currentItemId === 2
                          ? this.generateSuccessors(
                            legacy.bestowLegacy.create,legacy.bestowLegacy.create.notes ? legacy.bestowLegacy.create.notes : ''
                          )
                          : null}
                        {this.state.currentItemId === 2 ? (
                          <div className="mt-30">
                            <CapsuleButton text="Show Less" data-test="bestowToCreateShowLess" whiteBackground iconType="arrowUp" onClick={() => {
                              this.clickHandler(2);
                            }} />
                          </div>
                        ) : (
                            <div className="mt-30">
                              <CapsuleButton text="Show More" data-test="bestowToCreateShowMore" whiteBackground iconType="arrowDown" onClick={() => {
                                this.clickHandler(2, this.createAccountTitle);
                              }} />
                            </div>
                          )}
                      </ContentData>
                    </OptionsCard>
                  ) : (
                      ""
                    )}
                </>
              )}
          </>
        )}
        {/******************************** Endow to Charity ************************************/}
        {legacy.endowLegacy && (
          <>
            {legacy.endowLegacy.give && parseInt(legacy.endowLegacy.give.assignedPercentage) === 0 &&
              legacy.endowLegacy.endow && parseInt(legacy.endowLegacy.endow.assignedPercentage) === 0 &&
              legacy.endowLegacy.grant && parseInt(legacy.endowLegacy.grant.assignedPercentage) === 0 ? (
                ""
              ) : (
                <>
                  <DataValue className="mb-30">Endow to charity</DataValue>
                  {legacy.endowLegacy.endow && parseInt(legacy.endowLegacy.endow.assignedPercentage) !== 0 ? (
                    <OptionsCard>
                      <HeaderDataWrapper data-test="endowCharity" onClick={() => {
                        this.clickHandler(4);
                      }}>
                        <HeaderData>
                          <SectionLastHeading className="mb0">
                            <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="Legacy options" property="field_type_3_title" setTitle={(title) => this.setTitle(title, 'philanthropic')} defaultMessage="Philanthropic Impact Fund" />
                          </SectionLastHeading>
                          <DataHeading>
                            <ContentMessage messageId="philanthropicFund" type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="Legacy options" html={true} property="field_type_3_description" defaultMessage="Transfer the account's remaining assets to Vanguard Charitable's Philanthropic Impact Fund. This mission-driven fund supports charities that encourage charitable giving and philanthropy." />
                          </DataHeading>
                          <Percentage textColor="#69923a">
                            {legacy.endowLegacy.endow.assignedPercentage}%
                        </Percentage>
                        </HeaderData>
                      </HeaderDataWrapper>
                      <ContentData>
                        {this.state.currentItemId === 4 ? (
                          <>
                            <Divider className="my-20" />
                            <ItemHeading>
                              <PercentageImage>
                                <img src={Percent} alt="Percentage" />{"  "}
                                Percentage endowed
                            </PercentageImage>
                              <PercentageOthers>
                                {legacy.endowLegacy.endow.assignedPercentage}%
                          </PercentageOthers>
                            </ItemHeading>
                            {this.geminiUser &&
                              <GeminiViewContainerWithNotes>
                                <NotesStringContainer><ItemHeading>Notes: </ItemHeading></NotesStringContainer>
                                <NotesDataContainer>
                                  <ItemData>
                                    {legacy.endowLegacy.endow.notes ? legacy.endowLegacy.endow.notes : <> &mdash; </>}
                                  </ItemData>
                                </NotesDataContainer>
                              </GeminiViewContainerWithNotes>
                            }
                          </>
                        ) : null}
                        {this.state.currentItemId === 4 ? (
                          <div className="mt-30">
                            <CapsuleButton text="Show Less" data-test="endowCharityShowLess" whiteBackground iconType="arrowUp" onClick={() => {
                              this.clickHandler(4);
                            }} />
                          </div>
                        ) : (
                            <div className="mt-30">
                              <CapsuleButton text="Show More" data-test="endowCharityShowMore" whiteBackground iconType="arrowDown" onClick={() => {
                                this.clickHandler(4, this.philanthropicTitle);
                              }} />
                            </div>
                          )}
                      </ContentData>
                    </OptionsCard>
                  ) : (
                      ""
                    )}
                  {legacy.endowLegacy.give && parseInt(legacy.endowLegacy.give.assignedPercentage) !== 0 ? (
                    <OptionsCard>
                      <HeaderDataWrapper data-test="endowLegacyGiveHeader" onClick={() => {
                        this.clickHandler(3);
                      }}>
                        <HeaderData>
                          <SectionLastHeading className="mb0">
                            <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="Legacy options" property="field_type_4_title" setTitle={(title) => this.setTitle(title, 'giveToCharity')} defaultMessage="Give to charity" />
                          </SectionLastHeading>
                          <DataHeading>
                            <ContentMessage messageId="giveToCharity" type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="Legacy options" html={true} property="field_type_4_description" defaultMessage="Recommend grants to one or many charities." />
                          </DataHeading>
                          <Percentage textColor="#69923a">
                            {legacy.endowLegacy.give.assignedPercentage}%
                            </Percentage>
                        </HeaderData>
                      </HeaderDataWrapper>
                      <ContentData>
                        {this.state.currentItemId === 3 ? (
                          <CharityList>
                            <Divider className="my-20" />
                            {legacy.endowLegacy.give.successionPlanGranteeOrg && legacy.endowLegacy.give.successionPlanGranteeOrg.length > 0 ? (
                              legacy.endowLegacy.give.successionPlanGranteeOrg.map((item, index) => (
                                <Col lg={8} md={8} xs={24}>
                                  <Row>
                                    <Col lg={2} md={2} xs={2}>
                                      <div className="mt-05">
                                        {/* <Profile /> */}
                                        <CharityIcon src={Shelter} alt="ShelterIcon" />
                                      </div>
                                    </Col>
                                    <Col lg={22} md={22} xs={22}>
                                      <div className="mb1">
                                        <PersonnelHeading>
                                          Charity {index + 1}
                                        </PersonnelHeading>
                                      </div>
                                      <ItemData className="mt0">
                                        {item.name ? (
                                          item.name
                                        ) : (
                                            <> &mdash; </>
                                          )}
                                        {!!item.charityAllocPercent && (
                                          <>{` | ${parseFloat(item.charityAllocPercent).toFixed(2).replace(/\.0+$/,'')}%`}</>
                                        )}
                                      </ItemData>
                                      <DisplayFlex className="mt-05">
                                        <ItemHeading>EIN :</ItemHeading>
                                        <ItemData className="mt0 ml-05">
                                          {item.ein ? item.ein : <> &mdash; </>}
                                        </ItemData>
                                      </DisplayFlex>
                                      <DisplayFlex className="mt-05">
                                        <ItemHeading>Contact number :</ItemHeading>
                                        <ItemData className="mt0 ml-05">
                                          {item.contactPhone ? item.contactPhone : <> &mdash; </>}
                                        </ItemData>
                                      </DisplayFlex>
                                      <DisplayFlex className="mt-05">
                                        <ItemHeading>Web address :</ItemHeading>
                                        <ItemData className="mt0 ml-05">
                                          {item.webAddress ?
                                            <EllipsisDataValueWrapper>
                                              <EllipsisUnderline>{item.webAddress}</EllipsisUnderline>
                                              <EllipsisContent>
                                                {item.webAddress}
                                              </EllipsisContent>
                                            </EllipsisDataValueWrapper> : <> &mdash; </>}
                                        </ItemData>
                                      </DisplayFlex>
                                      <DisplayFlex className="mt-05">
                                        <ItemHeading>Address :</ItemHeading>
                                        <div>
                                          <ItemData className="mt0 ml-05">
                                            {item.address.line1
                                              ? `${item.address.line1}, `
                                              : ""}
                                          </ItemData>
                                          <ItemData className="mt0 ml-05">
                                            {item.address.line2
                                              ? `${item.address.line2}, `
                                              : ""}
                                          </ItemData>
                                          <ItemData className="mt0 ml-05">
                                            {item.address.line3
                                              ? `${item.address.line3}, `
                                              : ""}
                                          </ItemData>
                                          <ItemData className="mt0 ml-05">
                                            {item.address.line4
                                              ? `${item.address.line4}, `
                                              : ""}
                                          </ItemData>
                                          <ItemData className="mt0 ml-05">
                                            {item.address.city ? `${item.address.city}, ` : ""}
                                            {item.address.state ? `${item.address.state}, ` : null}
                                            {item.address.zip ? `${item.address.zip}, ` : ""}
                                          </ItemData>
                                          <ItemData className="mt0 ml-05">
                                            {item.address.country}
                                          </ItemData>
                                        </div>
                                      </DisplayFlex>
                                      <DisplayFlex className="mt-05">
                                        <ItemHeading>Grant Purpose :</ItemHeading>
                                        <ItemData className="mt0 ml-05">
                                          {item.grantPurpose ? item.grantPurpose === "Area of most need" ? "Area of most need" : item.otherGrantPurposeText : (
                                            <> &mdash; </>
                                          )}
                                        </ItemData>
                                      </DisplayFlex>
                                      <DisplayFlex className="mt-05">
                                        <ItemHeading>
                                          Grant Recognition :
                                        </ItemHeading>
                                        <ItemData className="mt0 ml-05">
                                          {item.grantRecognition ? (
                                            item.grantRecognition
                                          ) : (
                                              <> &mdash; </>
                                            )}
                                        </ItemData>
                                      </DisplayFlex>
                                    </Col>
                                  </Row>
                                </Col>
                              ))
                            ) : (
                                <ItemHeading>No Data found</ItemHeading>
                              )}
                          </CharityList>
                        ) : null}
                        {this.state.currentItemId === 3 ? (
                          <div className="mt-30">
                            <CapsuleButton text="Show Less" data-test="endowLegacyGiveShowLessCapsule" whiteBackground iconType="arrowUp" onClick={() => {
                              this.clickHandler(3);
                            }} />
                          </div>
                        ) : (
                            <div className="mt-30">
                              <CapsuleButton text="Show More" data-test="endowLegacyGiveShowMoreCapsule" whiteBackground iconType="arrowDown" onClick={() => {
                                this.clickHandler(3, this.giveCharityTitle);
                              }} />
                            </div>
                          )}
                      </ContentData>
                    </OptionsCard>
                  ) : ""
                  }
                  {legacy.endowLegacy.grant && parseInt(legacy.endowLegacy.grant.assignedPercentage) !== 0 ? (
                    <OptionsCard>
                      <HeaderDataWrapper data-test="endowLegacyGrantHeader" onClick={() => {
                        this.clickHandler(5);
                      }}>
                        <HeaderData>
                          <SectionLastHeading className="mb0">
                            <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="Legacy options" property="field_type_5_title" setTitle={(title) => this.setTitle(title, 'grantAnnually')} defaultMessage="Grant annually" />
                          </SectionLastHeading>
                          <DataHeading id="grantAnually">
                            <ContentMessage messageId="endowed" type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="Legacy options" html={true} property="field_type_5_description" setTitle={this.viewEndowedGrantPlanPdf} defaultMessage={'Recommend an Endowed Grant Plan. See our <a href="/company-policies/policies-and-guidelines" target="_blank">Policies and guidelines</a> and complete a Recommend an <a href="/sites/default/files/2019-05/EndowedGrantForm.pdf" target="_blank">Endowed Grant Plan form</a>.'} />
                          </DataHeading>
                          <Percentage textColor="#69923a">
                            {legacy.endowLegacy.grant.assignedPercentage}%
                        </Percentage>
                        </HeaderData>
                      </HeaderDataWrapper>
                      <ContentData>
                        {this.state.currentItemId === 5 ? (
                          <>
                            <Divider className="my-20" />
                            <CharityList>
                              {legacy.endowLegacy.grant.successionPlanGranteeOrg && legacy.endowLegacy.grant.successionPlanGranteeOrg.length > 0
                                ? legacy.endowLegacy.grant.successionPlanGranteeOrg.map(
                                  (data, index) => (
                                    <Col lg={8} md={8} xs={24}>
                                      <Row>
                                        <Col lg={2} md={2} xs={2}>
                                          <div className="mt-05">
                                            {/* <Profile /> */}
                                            <CharityIcon src={Shelter} />
                                          </div>
                                        </Col>
                                        <Col lg={22} md={22} xs={22}>
                                          <div className="mb1">
                                            <PersonnelHeading>
                                              Charity {index + 1}
                                            </PersonnelHeading>
                                          </div>
                                          <ItemData className="mt0">
                                            {
                                              data.charityAllocPercent && parseFloat(data.charityAllocPercent) > 0
                                              ? `${data.name} - ${parseFloat(data.charityAllocPercent).toFixed(2).replace(/\.0+$/,'')}%`
                                              : data.name
                                            }                                           
                                          </ItemData>
                                          <DisplayFlex className="mt-05">
                                            <ItemHeading>EIN :</ItemHeading>
                                            <ItemData className="mt0 ml-05">
                                              {data.ein ? data.ein : <> &mdash; </>}
                                            </ItemData>
                                          </DisplayFlex>
                                          <DisplayFlex className="mt-05">
                                            <ItemHeading>City :</ItemHeading>
                                            <ItemData className="mt0 ml-05">
                                              {data.address.city ? data.address.city : <> &mdash; </>}
                                            </ItemData>
                                          </DisplayFlex>
                                          <DisplayFlex className="mt-05">
                                            <ItemHeading>State :</ItemHeading>
                                            <ItemData className="mt0 ml-05">
                                              {data.address.state ? data.address.state : <> &mdash; </>}
                                            </ItemData>
                                          </DisplayFlex>
                                          <DisplayFlex className="mt-05">
                                            <ItemHeading>Country :</ItemHeading>
                                            <ItemData className="mt0 ml-05">
                                              {data.address.country ? data.address.country : <> &mdash; </>}
                                            </ItemData>
                                          </DisplayFlex>
                                        </Col>
                                      </Row>
                                    </Col>
                                  )
                                )
                                : <ItemHeading>
                                  <PercentageImage>
                                    <img src={Percent} />
                                    {"  "}
                                    Percentage endowed
                          </PercentageImage>
                                  <PercentageOthers>
                                    {legacy.endowLegacy.grant.assignedPercentage}%
                          </PercentageOthers>
                                </ItemHeading>}
                              {this.geminiUser &&
                                <GeminiViewContainerWithNotes>
                                  <NotesStringContainer><ItemHeading>Notes: </ItemHeading></NotesStringContainer>
                                  <NotesDataContainer>
                                    <ItemData>
                                      {legacy.endowLegacy.grant.notes ? legacy.endowLegacy.grant.notes : <> &mdash; </>}
                                    </ItemData>
                                  </NotesDataContainer>
                                </GeminiViewContainerWithNotes>
                              }
                            </CharityList>
                          </>
                        ) : null}
                        {this.state.currentItemId === 5 ? (
                          <div className="mt-30">
                            <CapsuleButton text="Show Less" data-test="endowLegacyGrantShowLess" whiteBackground iconType="arrowUp" onClick={() => {
                              this.clickHandler(5);
                            }} />
                          </div>
                        ) : (
                            <div className="mt-30">
                              <CapsuleButton text="Show More" data-test="endowLegacyGrantShowMore" whiteBackground iconType="arrowDown" onClick={() => {
                                this.clickHandler(5, this.grantAnnualTitle);
                              }} />
                            </div>
                          )}
                      </ContentData>
                    </OptionsCard>
                  ) : (
                      ""
                    )}
                </>
              )}
          </>
        )}
        {/******************************* Other Legacy Options **************************************/}
        {legacy.otherLegacy && (
          <>
            {parseInt(legacy.otherLegacy.assignedPercentage) !== 0 ? (
              <>
                <DataValue className="mb-30"></DataValue>
                <OptionsCard>
                  <HeaderDataWrapper data-test="otheraLegacyHeader" onClick={() => {
                    this.clickHandler(6);
                  }}>
                    <HeaderData>
                      <SectionLastHeading className="mb0">
                        Others
                      </SectionLastHeading>
                      <DataHeading>
                        {legacy.otherLegacy.notes ? legacy.otherLegacy.notes : <> &mdash; </>}
                      </DataHeading>
                      <Percentage textColor="#00677891">
                        {legacy.otherLegacy.assignedPercentage}%
                      </Percentage>
                    </HeaderData>
                  </HeaderDataWrapper>
                  <ContentData>
                    {this.state.currentItemId === 6 ? (
                      <>
                        <Divider className="my-20" />
                        <ItemHeading>
                          <PercentageImage>
                            <img src={Percent} />{"  "}
                            Percentage endowed
                            </PercentageImage>
                          <PercentageOthers>
                            {legacy.otherLegacy.assignedPercentage}%
                        </PercentageOthers>
                        </ItemHeading>
                      </>
                    ) : null}
                    {this.state.currentItemId === 6 ? (
                      <div className="mt-30">
                        <CapsuleButton text="Show Less" data-test="otherLegacyShowLess" whiteBackground iconType="arrowUp" onClick={() => {
                          this.clickHandler(6);
                        }} />
                      </div>
                    ) : (
                        <div className="mt-30">
                          <CapsuleButton text="Show More" data-test="otherLegacyShowMore" whiteBackground iconType="arrowDown" onClick={() => {
                            this.clickHandler(6, "Other");
                          }} />
                        </div>
                      )}
                  </ContentData>
                </OptionsCard>
              </>
            ) : (
                ""
              )}
          </>
        )}
      </div>
    );
  }
}
SuccessionComponent.propTypes = {
  data: PropTypes.object,
  pageTitle: PropTypes.func
};
